module.exports = __webpack_public_path__ + "img/technical_support_02.ec6be7b9.jpg";